import Vue from "vue";
import Toolkit from "@/util/toolkit";

Vue.filter("fileSizeFilter", function (value) {
  return Toolkit.transferFileSize(value);
});

Vue.filter("fileNameFilter", function (value) {
  return Toolkit.getFileNameFromUrl(value);
});
